import { useStudioStore } from '@/store/studio-store'

export type StudioLaunchChatSource = 'blank' | 'template' | 'template-remix' | 'project-open'

interface OpenStudioLaunchChatInput {
  source: StudioLaunchChatSource
  projectName: string
  templateName?: string | null
}

function buildLaunchNotice(input: OpenStudioLaunchChatInput): string {
  if (input.source === 'project-open') {
    return `${input.projectName} is open. Tell coogo what to change, then review it before sharing or launching.`
  }

  if (input.source === 'template' || input.source === 'template-remix') {
    const templateName = input.templateName?.trim() || input.projectName
    return `${templateName} is ready. Tell coogo what copy, pages, data, or checkout should change; review it here before it goes live.`
  }

  return `${input.projectName} is ready. Tell coogo what to build next, then share, export, or launch when it is ready.`
}

export function openStudioLaunchChat(input: OpenStudioLaunchChatInput): void {
  const store = useStudioStore.getState()
  store.setInspectorPanelOpen(false)
  store.setChatSidebarOpen(true)
  store.setPendingChatNotice(buildLaunchNotice(input))
}
